module.exports = __webpack_public_path__ + "images/deluxe-fb35d09737750be9be2077bbbaed1699.jpg";